import { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";

import { loginRequest, requiredAppRole } from "../config/authConfig";
import { AppTokenProvider } from '../contexts/AppTokenContext';
//components
import { MainContainer } from "../components/MainContainer";
import { UserProvider } from "../contexts/UserContext";
import ErrorMsg from "../components/ErrorMsg/ErrorMsg";

export function UseAccessToken() {
    
    const { instance, accounts } = useMsal();
    const [accessTokenSsoObj, setAccessTokenSsoObj] = useState({});
    const [userDetails, setUserDetails] = useState("");

    const account = accounts[0];
    const accountRoles = Array.isArray(account?.idTokenClaims?.roles) ? account.idTokenClaims.roles : [];
    const hasRequiredRole = accountRoles.includes(requiredAppRole);

    const getUserAccessToken = () => {
        if (account && hasRequiredRole) {
            setUserDetails(account.name);
            let ssoId = account.username.split("@")[0];
            instance.acquireTokenSilent({
                ...loginRequest,
                account
            }).then((response) => {console.log("response", response)
                setAccessTokenSsoObj({
                    ssoId: ssoId,
                    accessToken: response.accessToken
                });
            }).catch(error => {
                // acquireTokenSilent can fail for a number of reasons, fallback to interaction
                console.log(error);
            });
        }
    }

    useEffect(()=>{
        if (!hasRequiredRole) {
            return;
        }
        getUserAccessToken();
    },[account, hasRequiredRole]);

    if (account && !hasRequiredRole) {
        return (
            <div style={{ display: "flex", justifyContent: "center", marginTop: "4rem" }}>
                <ErrorMsg errorMsg={`You are authenticated but not authorized. Required role: ${requiredAppRole}.`} />
            </div>
        );
    }

    return (
        <AppTokenProvider value={accessTokenSsoObj}>
            <UserProvider value={userDetails}>
                <MainContainer />
            </UserProvider>
        </AppTokenProvider>
    )
}
